import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Role gate. A role matches the user's canonical `dashboard_role` (what the
 * API's UserResource sends: 'vendor', 'customer-service', 'system-admin',
 * 'client-admin', 'client') or an entry of the optional `roles[]` list.
 *
 * Usage in routes:
 *   {
 *     path: 'vendor-portal',
 *     canActivate: [roleGuard],
 *     data: { roles: ['vendor', 'customer-service', 'system-admin'] }
 *   }
 */
export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const requiredRoles = (route.data['roles'] as string[]) ?? [];

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/authentication']);
  }

  if (requiredRoles.length === 0) {
    return true;
  }

  const dashboardRole = auth.user()?.dashboard_role;
  const hasAccess = requiredRoles.some((role) => role === dashboardRole || auth.hasRole(role));
  return hasAccess ? true : router.createUrlTree(['/forbidden']);
};
